export default "__VITE_ASSET__SCH_0AEF__"